module.exports = "/build/web/svg/event/supporter.9d00ee0c59da54437c1886009dc11dac.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/event/supporter.svg
// module id = 159
// module chunks = 24